import { ApiWeeklySchedule } from 'apis/merchant-onboarding-service/types';
import { WeeklySchedule, WeeklyScheduleEvent } from 'common/components/weekly-schedules/types';

import fromTimePairsByWeekdayToWeeklySchedule from './WeeklyScheduleInput/fromTimePairsByWeekdayToWeeklySchedule';
import { SelfServeSignupValues, SelfServeSignupRequest } from './types';

type TransformedFormValues = Omit<SelfServeSignupRequest, 'tags' | 'woltUid'>;

const transformToApiFormat = (weeklySchedule: WeeklySchedule): ApiWeeklySchedule => {
  const unwrapMongoDate = (event: WeeklyScheduleEvent) => ({
    type: event.type,
    value: event.value.$date,
  });

  return {
    monday: weeklySchedule.monday.map(unwrapMongoDate),
    tuesday: weeklySchedule.tuesday.map(unwrapMongoDate),
    wednesday: weeklySchedule.wednesday.map(unwrapMongoDate),
    thursday: weeklySchedule.thursday.map(unwrapMongoDate),
    friday: weeklySchedule.friday.map(unwrapMongoDate),
    saturday: weeklySchedule.saturday.map(unwrapMongoDate),
    sunday: weeklySchedule.sunday.map(unwrapMongoDate),
  };
};

export const formValuesToApi = (formValues: SelfServeSignupValues): TransformedFormValues => {
  // TODO: add website fields when website is added back

  const {
    phoneNumber: formPhoneNumber,
    venues: formVenues,
    firstName: formFirstName,
    lastName: formLastName,
    name: formBusinessName,
    email: formEmail,
    // website: formWebsite,
    businessId: formBusinessId,
    businessType: formBusinessType,
  } = formValues;

  const isNonWoltCity = !formValues.venues.isWoltCity;

  const venue = {
    name: formVenues.name.trim(),
    address: formVenues.address.trim(),
    postCode: formVenues.postCode.trim(),
    city: isNonWoltCity ? formValues.venues.otherCity?.trim() : formVenues.city.trim(),
    isWoltCity: formVenues.isWoltCity,
    openingTimes: transformToApiFormat(fromTimePairsByWeekdayToWeeklySchedule(formVenues.openingHours)),
  };

  const firstName = formFirstName.trim();
  const lastName = formLastName.trim();
  const name = formBusinessName.trim();
  const email = formEmail.trim();
  // const website = !!formWebsite ? formWebsite.trim() : undefined;
  const phoneNumber = `${formPhoneNumber.extension}${formPhoneNumber.number.trim()}`;
  const venues = [venue];
  const businessId = formBusinessId.trim();
  const businessType = formBusinessType.trim();

  return {
    ...formValues,
    firstName,
    lastName,
    name,
    phoneNumber,
    email,
    venues,
    // website,
    businessId,
    businessType,
  };
};
